module.exports = __webpack_public_path__ + "static/media/Synopsis - It Makes Sense to Believe.12d6a700.docx";